import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import { enums } from 'console-kit';

import Actions from '../actions';

const initialState = Immutable({
  isModalVisible:      false,
  templatePickerState: enums.pickerStates.LOADING,
  templateEmailList:   [],
});

const emailTemplatePickerReducer = createReducer((on) => {
  on(Actions.updateTemplatePickerState, (state, { templatePickerState }) =>
    state.set('templatePickerState', templatePickerState)
  );

  on(Actions.openEmailTemplatePicker, (state) => {
    return state.merge({
      // by keeping this as loading by default, you avoid a little "jank" when the tick mark shows up very briefly before the api call kicks in
      templatePickerState: enums.pickerStates.LOADING,
      isModalVisible:      true,
    });
  });

  on(Actions.closeEmailTemplatePicker, (state) => state.set('isModalVisible', false));

  on(Actions.setEmailTemplatePickerList, (state, { templateEmailList }) => {
    return state.set('templateEmailList', templateEmailList);
  });
}, initialState);

export default emailTemplatePickerReducer;
